import { Dropdown } from "capitalrx-components-2.0/lib/forms";
import { ComponentProps } from "react";
import "./TextDropdown.scss";

const TextDropdown = (props: ComponentProps<typeof Dropdown>) => {
  const className = ["text-dropdown", props.className].filter(Boolean).join(" ");
  return <Dropdown {...props} className={className} />;
};

export default TextDropdown;
